import React from 'react';
import styles from './index.module.css';
import { useStore } from '../../lib/store';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Grid, Column } from '../ui/Grid';
import { useForm } from 'react-hook-form';
import { Step } from './step';
import { Textarea } from '../ui/Textarea';

export const StepOffer = ({
  number,
  title,
  status,
  isLast
}) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { 
    hasSubmitted,
    setHasSubmitted,
    offer,
    setOffer
  } = useStore();

  const submitHubspotForm = async () => {
    try {
      if(hasSubmitted) return;

      const portalId = '383975';
      const formGuid = 'c5ca2aa2-3057-4edb-ba13-be442e2f50a2';
      
      const {
        firstName,
        lastName,
        email,
        phone,
        location,
        company,
        website,
        offer
      } = useStore.getState();
  
      const response = await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          portalId,
          formGuid,
          fields: [
            { name: 'firstname', value: firstName },
            { name: 'lastname', value: lastName },
            { name: 'email', value: email },
            { name: 'phone', value: phone },
            { name: 'company', value: company },
            { name: 'company_location', value: location },
            { name: 'company_url', value: website },
            { name: 'twn_offer', value: offer }
          ],
        }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const responseData = await response.json();
      setHasSubmitted(true);
      return responseData;
    } catch (e) {
      console.log('error:', e);
    }
  };

  const canContinue = offer && Object.keys(errors).length === 0;

  const onSubmit = async (data) => {
    if(!data.offer) return;
    setOffer(data.offer);
    const response = await submitHubspotForm();
    if (response) {
      window.location.href = '/application-thank-you';
    }
  }

  return (
    <Step {...{number, title, status, isLast}}>
      <p className={styles.description}>Finally, tell us what you'd like to offer our customers.</p>
      <form onSubmit={handleSubmit(async (data) => onSubmit(data))}>
        <Grid className={styles.inputGroup}>
          <Column span={[12]}>
            <Textarea
              placeholder="E.g. 25% off your first massage"
              name="offer"
              {...register("offer", {
                required: "Please describe what you're offering"
              })}
              onChange={(e) => setOffer(e.target.value)}
              error={errors.offer}
            />
          </Column>
        </Grid>
        {Object.keys(errors).length > 0 && (
          <div className={styles.errors}>
            <ErrorMessage
              errors={errors}
              name="offer"
              render={({ message }) => <p>{message}</p>}
            />
          </div>
        )}
        <Button
          type="submit"
          icon="check"
          fullWidth
          disabled={!canContinue}
        >
          {canContinue ? 'Apply Now' : 'Please complete the field'}
        </Button>
      </form>
    </Step>
  );
}